import { useEffect, useId, useRef, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function EventFilters({ children, count = 0 }: { children: ReactNode; count?: number }) {
  const { t } = useTranslation();
  const titleId = useId();
  const dialog = useRef<HTMLDialogElement>(null);
  const [mobile, setMobile] = useState(() => window.matchMedia('(max-width: 640px)').matches);
  useEffect(() => {
    const query = window.matchMedia('(max-width: 640px)');
    const update = () => setMobile(query.matches);
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  if (!mobile) return <div className="event-filters__desktop">{children}</div>;
  return <>
    <button type="button" className="button button--primary event-filters__trigger" aria-haspopup="dialog" onClick={() => dialog.current?.showModal()}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M4 7h16M7 12h10M10 17h4" /></svg>
      {t('eventDetail.filters.title')}{count > 0 && <span>({count})</span>}
    </button>
    <dialog ref={dialog} className="event-filters__dialog" aria-labelledby={titleId} onClick={event => { if (event.target === event.currentTarget) dialog.current?.close(); }}>
      <div className="event-filters__sheet">
        <header><h2 id={titleId}>{t('eventDetail.filters.title')}</h2><button type="button" className="button button--quiet" aria-label={t('eventDetail.filters.close')} onClick={() => dialog.current?.close()}>×</button></header>
        {children}
        <button type="button" className="button button--primary" onClick={() => dialog.current?.close()}>{t('eventDetail.filters.done')}</button>
      </div>
    </dialog>
  </>;
}
